import { Loading } from '@evertrue/et-components';
import { useState } from 'react';
import { PropTypes } from 'base/react-libs';
import SideBar from 'components/animations/side-bar';
import DueDatePicker from '../top-nav/due-date-picker';
import ContactSummary from 'apps/contact/components/contact-summary/contact-summary';
import JourneysBanner from '../top-nav/journeys-banner';
import JourneyDetailTable from './journey-detail-table/journey-detail-table';
import JourneyPauseContainer from '../top-nav/journeys-pause-container';
import JourneyDetailTableToggle from './journey-detail-table/journey-detail-table-toggle';

const JourneyDetail = ({
  user = {},
  journey = {},
  stepEmpty,
  userIsCreator,
  loadingJourney = false,
  selectedContact,
  setSelectedContact = () => {},
  selectedDueDate,
  setSelectedDueDate = () => {},
  optionalStateManagementFunction = () => {},
  setActiveFilter,
  actionTypes,
  activeFilter,
  allSelectedTasks,
  setAllSelectedTasks,
}) => {
  const [viewSideBar, setViewSideBar] = useState(false);
  const [tableView, setTableView] = useState('steps');

  const closeSideBar = () => {
    setViewSideBar(false);
  };
  const openContactSummary = (contact) => {
    setSelectedContact(contact);
    setViewSideBar(true);
  };

  return loadingJourney ? (
    <Loading />
  ) : (
    <>
      <JourneysBanner
        journey={journey}
        userIsCreator={userIsCreator}
        optionalStateManagementFunction={optionalStateManagementFunction}
        selectedDueDate={selectedDueDate}
        allSelectedTasks={allSelectedTasks}
        setAllSelectedTasks={setAllSelectedTasks}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', paddingLeft: '16px', paddingRight: '16px' }}>
        {tableView === 'activeConstituents' ? (
          <div />
        ) : (
          <DueDatePicker selectedDueDate={selectedDueDate} setSelectedDueDate={setSelectedDueDate} />
        )}
        <JourneyDetailTableToggle tableView={tableView} setTableView={setTableView} />
      </div>
      <JourneyPauseContainer />
      <JourneyDetailTable
        user={user}
        journey={journey}
        stepEmpty={stepEmpty}
        selectedContact={selectedContact}
        userIsCreator={userIsCreator}
        openContactSummary={openContactSummary}
        optionalStateManagementFunction={optionalStateManagementFunction}
        setActiveFilter={setActiveFilter}
        actionTypes={actionTypes}
        activeFilter={activeFilter}
        viewSideBar={viewSideBar}
        allSelectedTasks={allSelectedTasks}
        setAllSelectedTasks={setAllSelectedTasks}
        setTableView={setTableView}
        tableView={tableView}
      />
      <SideBar
        start={viewSideBar}
        closeSideBar={closeSideBar}
        speed={1000}
        mountOnEnter={true}
        unmountOnExit={true}
        enableEnterAnimations={true}
        enableExitAnimations={true}
        enableAppearAnimations={true}
        onExited={() => setSelectedContact(null)}
      >
        <ContactSummary contactFromGql={selectedContact} />
      </SideBar>
    </>
  );
};

JourneyDetail.propTypes = {
  user: PropTypes.object,
  journey: PropTypes.object.isRequired,
  stepEmpty: PropTypes.bool,
  userIsCreator: PropTypes.bool,
  loadingJourney: PropTypes.bool,
  selectedContact: PropTypes.object,
  setSelectedContact: PropTypes.func,
  selectedDueDate: PropTypes.string,
  setSelectedDueDate: PropTypes.func,
  optionalStateManagementFunction: PropTypes.func,
  setActiveFilter: PropTypes.func,
  actionTypes: PropTypes.array,
  activeFilter: PropTypes.array,
  allSelectedTasks: PropTypes.array,
  setAllSelectedTasks: PropTypes.func,
};

export default JourneyDetail;
